import { PropsWithChildren, useContext, useEffect } from 'react';
import { Box, Slide } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from './header/header'
import Footer from './footer/footer'
import { AuthContext } from '../../../contexts/auth/authContext'
import { DataContext } from '../../../contexts/data/dataContext'
import { useGetCurrentSession } from '../../../services/api-query/auth'
import ChatEntry from '../../right-panel/help/chatEntry'
import custom from '../../../styles/mui/szVariables.json'

export default function MainLayout({ children }: PropsWithChildren) {
    const border = custom.border
    const tablet = useMediaQuery('(min-width:600px)');
    const auth = useContext(AuthContext)
    const data = useContext(DataContext)
    const { errorSession } = useGetCurrentSession() 

    if(data?.rightPanel && tablet) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflowY = 'scroll';
        document.body.style.overflowX = 'hidden';
    }

    useEffect(() => {
        if(errorSession) auth.signOut();
    },[errorSession, auth])

  
    return (
        <Box border={auth?.staff?custom.borderRed:0} zIndex={9999}>
            <Header />
            {/* Main Content */}
            <Box 
                // width="100vw"
                display="flex" id="MainContent"
                flexDirection={"row"} 
                justifyContent={"center"}
                mt={custom.sizes.hf}
                minHeight="calc(100vh - 144px)"
                >     
                {/* Main Panel */}
                <Box borderRight={data.rightPanel?border:0}
                    display="flex" 
                    flexDirection={"column"} 
                    justifyContent={"flex-star"}
                    alignItems={"center"}
                    boxShadow={"border-box"}
                    sx={{
                        display: { 
                            xs: data.rightPanel ? 'none' : 'flex', 
                            sm: 'flex', md: 'flex', 
                            lg: 'flex', xl: 'flex' 
                        },
                    }}
                    width={{
                        xs:data.rightPanel?0:"100vw", 
                        sm:"100%", 
                        md:"100%", 
                        lg:"100%"
                    }}
                    > 
                    <Box width="100%"
                        display="flex" 
                        flexDirection={"row"} 
                        justifyContent={"center"}
                        maxWidth= "1200px"
                        >       
                        <Box id='mainPanel' 
                            display="flex" 
                            flexDirection={"column"} 
                            justifyContent={"flex-start"}
                            // pb={{ xs:5, sm:15, md:15, lg:10, xl:15}} 
                            pb={data?.rightPanel?15:5}
                            sx={{
                                pt: custom.spacing.md,
                                // mx: custom.spacing.md,
                                maxWidth: '100%',                                   
                                flex:1,  
                                height: {
                                        xs: 'auto',
                                        sm: data?.rightPanel?'75vh':'auto',
                                        md: data?.rightPanel?'80vh':'auto',
                                        lg: data?.rightPanel?'80vh':'auto',
                                        xl: data?.rightPanel?'90vh':'auto',
                                        xxl: data?.rightPanel?'90vh':'auto',
                                    },
                                overflowX: 'hidden',
                                overflowY: 'scroll',
                                '&::-webkit-scrollbar': {
                                    display: "none"
                                }
                            }}> 
                            {children}
                        </Box>   
                    </Box>
                    
                </Box>
                {/* Right Panel */}
                <Box sx={{ 
                        display: `${data.rightPanel}?'flex':'none'`,
                        mt: custom.sizes.hf,
                    }}
                    boxSizing={'border-box'}
                    flexDirection={"row"} 
                    justifyContent={"flex-end"}
                    >
                    <Box display="flex" 
                            boxSizing={'border-box'}
                            flexDirection={"column"} 
                            justifyContent={"flex-end"}
                        >
                        <Slide direction={
                                `${data.rightPanel?.key==='help'?
                                                    'up':'left'}`} 
                                in={!!data.rightPanel} 
                                timeout={
                                    data.rightPanel?.key==='help'? {
                                        enter: 0,
                                        exit: 0
                                    }: undefined}
                                mountOnEnter unmountOnExit >
                            <Box id="rightPanel"
                                width={{ 
                                        xs:'98vw', 
                                        sm:'330px', 
                                        md:'400px', 
                                        lg:'400px', 
                                        xl:'400px' }}
                                    >
                                {data.rightPanel}
                            </Box>
                        </Slide>
                    </Box>
                    {data.rightPanel?.key==="help"?<ChatEntry />:<></>}
                </Box>   
            </Box>
            <Footer />
        </Box>  
      );
}
